import React from 'react';
import { ListOrdered } from '@good/icons';

import { useRichTextEditor } from '../rich-text-editor-context';
import { MenuButton } from './menu-button';

export const OrderedListButton = () => {
  const { editor, disabled } = useRichTextEditor();

  const isDisabled = disabled || !editor.can().chain().focus().toggleOrderedList().run();
  const onClick = () => editor.chain().focus().toggleOrderedList().run();
  const variant = editor.isActive('orderedList') ? 'filled' : 'transparent';

  return (
    <MenuButton onClick={onClick} disabled={isDisabled} variant={variant} aria-label='ordered-list'>
      <ListOrdered />
    </MenuButton>
  );
};
